var React = require('react');

function ArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M27.665 0L26.26 1.441l3.937 4.04H0v2.038h30.196l-3.937 4.04L27.665 13 34 6.501z"}));
}

ArrowRight.defaultProps = {"width":"34","height":"13"};

module.exports = ArrowRight;

ArrowRight.default = ArrowRight;
